import React from "react";
import "./index.css";
import { useNavigate } from "react-router-dom";
import { useTheme } from "../../contexts/ThemeContext";
//import logoSence from '../../assets/Logo_sence_blanco.png'
import { MultiLangText } from "../../utils/multilang";
import { useAuth } from "../../contexts/AuthContext";

export const CourseCard = ({ item = null, moodle, lang, imgurl, categoryName }) => {
  const theme = useTheme();
    const { dictionary } = useAuth();
  const navigation = useNavigate();
  const backgroundref = React.useRef(null);


  const handleNavigation = (percentage) => {
    moodle.setCurrentModules(null);
    navigation(`/detailcourse/${item.id}`);
  };

  const progress = item?.progress?.toFixed(0) || 0;

  return (
    <div className="relative w-full max-w-[320px]">
      {/* Outer Glow Container - Similar al login */}
      <div
        style={{
          position: "absolute",
          top: "-10px",
          left: "-10px",
          right: "-10px",
          bottom: "-10px",
          backgroundColor: "#2e2e3933",
          borderRadius: "24px",
          filter: "blur(20px)",
          opacity: "0.3",
          zIndex: 0,
        }}
      ></div>

      {/* Gradient Border Container */}
      {/* <div
        className="relative z-10 my-5 rounded-[10px] border-[1px] transition-all duration-300 group" */}
        {/* style={{
          padding: '10px',
          borderColor: theme.mode === "dark" ? "#66666699" : "#e2e8f0",
          background: theme.mode === "dark" 
            ? 'linear-gradient(123deg, rgba(113, 113, 113, 0.67) 0%, rgb(4, 4, 4) 100%)'
            : 'linear-gradient(135deg, #e2e8f033 0%, #cbd5e133 100%)'
        }} */}
      {/* > */}
        {/* Card Content */}
        <div
        className="relative z-10 my-5 rounded-[10px] border-[1px] overflow-hidden transition-all duration-300 group backdrop-blur-sm shadow-xl"
        style={{
          backgroundColor: theme.mode === "dark" ? "#1a1a1a" : "#ffffff",
          borderColor: theme.mode === "dark" ? "#66666699" : "#e2e8f0",
        }}
      >
          {/* Image Container */}
          <div className="relative h-[180px] overflow-hidden">
            <div
              ref={backgroundref}
              style={{ backgroundImage: `url(${imgurl})` }}
              className="h-full w-full bg-cover bg-center transform group-hover:scale-110 group-hover:-translate-y-4 transition-transform duration-500"
            />
            
            {/* Gradient Overlay */}
            <div className="absolute inset-0 bg-gradient-to-t from-black/30  via-black/5  to-transparent"></div>
            

            {/* Sence Logo */}
            {item && item.idnumber.includes("sence") && (
              {/* <div className="absolute bottom-2 right-2">
                <img 
                  src={logoSence} 
                  alt="logo-sence" 
                  className="w-28 h-auto drop-shadow-2xl" 
                />
              </div> */}
            )}

            {/* Progress Badge */}
          </div>

          {/* Content Section */}
          <div className="flex flex-col flex-grow px-5 pb-5 pt-[1rem]">
            
            {/* Category Tag */}
              <div className="h-[26px] mb-2">
            {categoryName ? (
                <span 
                  className="inline-block px-2 py-1.5 mb-2 text-base font-outfit rounded-[3px] backdrop-blur-md "
                  style={{
                    backgroundColor: theme.mode === 'dark' ? 'rgba(255, 255,255, 0.7)' : 'rgba(0, 0, 0, 0.1)',
                    color: theme.mode === 'dark'? '#2C2C3899' : '#2E2E3899',
                    border: `1px solid ${theme.colors.primary_light + '33'}`,
                    fontSize:'12px'
                  }}
                >
                  {categoryName}
                </span>
                ) : (
                    <div className="h-[26px] bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 dark:from-gray-700 dark:via-gray-600 dark:to-gray-700 rounded w-24 animate-pulse"></div>
                )
                }
              </div>
            {/* Course Title */}
            <h2
              className="text-2xl font-outfit  line-clamp-2 mb-4 min-h-[41px]"
              style={{ color: theme.mode === "light" ? "#1a1a1a" : "#ffffff",
                fontSize:'17px'
               }}
              title={item.fullname}
            >
              <MultiLangText content={item.fullname} currentLang={lang} />
            </h2>

            {/* Progress Section */}
            <div className="mt-auto space-y-2">
              {/* Progress Label */}
              <div className="flex justify-between items-center ">
                <span 
                  className="text-base font-medium "
                  style={{ color: theme.mode === "light" ? "#64748b" : "#94a3b8" }}
                >
                  Progreso
                </span>
                <span 
                  className="text-base font-bold "
                  style={{ color: theme.colors.backgroundColorCardBtn }}
                >
                  {item?.progress > 0 && item?.progress < 1
                    ? Number(item.progress).toFixed(1)
                    : (item?.progress?.toFixed(0) || 0)}% {dictionary.Home.course_progress}
                </span>
              </div>

              {/* Progress Bar */}
              <div className="w-full h-2.5 bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden">
                <div
                  className="h-full rounded-full transition-all duration-500 ease-out"
                  style={{
                    width: `${Math.min(100, Math.max(0, item?.progress || 0))}%`,
                    background: `linear-gradient(90deg, ${theme.colors.primary_light} 0%, ${theme.colors.tertiary_light} 100%)`,
                  }}
                ></div>
              </div>

              {/* Action Button */}
              <button
                onClick={handleNavigation}
                type="button"
                style={{ backgroundColor: theme.mode === "light" ? theme.colors.primary_dark : theme.colors.primary_light }}
                className="w-full mt-4 py-3 px-4 rounded-[3px] text-white font-outfit font-semibold text-2xl transition-all duration-300 transform hover:shadow-lg active:scale-95"
              >
                {dictionary.Home.course_btn}
              </button>
            </div>
          </div>
        </div>
      {/* </div> */}
    </div>
  );
};